import p1_1 from "../resources/images/projectphotos/project1/p1_1.jpeg";
import p1_2 from "../resources/images/projectphotos/project1/p1_2.jpg";
import p1_3 from "../resources/images/projectphotos/project1/p1_3.jpg";
import p1_4 from "../resources/images/projectphotos/project1/p1_4.jpg";
import p1_5 from "../resources/images/projectphotos/project1/p1_5.jpg";
import p1_6 from "../resources/images/projectphotos/project1/p1_6.jpg";
import p1_7 from "../resources/images/projectphotos/project1/p1_7.jpg";
import p1_8 from "../resources/images/projectphotos/project1/p1_8.jpg";
import p1_9 from "../resources/images/projectphotos/project1/p1_9.jpg";
import p1_10 from "../resources/images/projectphotos/project1/p1_10.jpg";
import p1_11 from "../resources/images/projectphotos/project1/p1_11.jpg";
import p1_12 from "../resources/images/projectphotos/project1/p1_12.jpg";

import p2_11 from "../resources/images/projectphotos/project2/11.JPG";
import p2_12 from "../resources/images/projectphotos/project2/12.JPG";
import p2_13 from "../resources/images/projectphotos/project2/13.png";
import p2_14 from "../resources/images/projectphotos/project2/14.jpg";
import p2_15 from "../resources/images/projectphotos/project2/15.jpg";
import p2_16 from "../resources/images/projectphotos/project2/16.jpg";
import p2_17 from "../resources/images/projectphotos/project2/17.jpg";
import p2_18 from "../resources/images/projectphotos/project2/18.jpg";
import p2_19 from "../resources/images/projectphotos/project2/19.jpg";
import p2_20 from "../resources/images/projectphotos/project2/20.jpeg";
import p2_21 from "../resources/images/projectphotos/project2/21.jpg";
import p2_22 from "../resources/images/projectphotos/project2/22.jpeg";
import p2_23 from "../resources/images/projectphotos/project2/23.jpeg";
import p2_24 from "../resources/images/projectphotos/project2/24.jpeg";

import p3_18 from "../resources/images/projectphotos/project3/18.jpg";
import p3_19 from "../resources/images/projectphotos/project3/19.jpg";
import p3_20 from "../resources/images/projectphotos/project3/20.JPG";
import p3_21 from "../resources/images/projectphotos/project3/21.JPG";

import p4_20 from "../resources/images/projectphotos/project4/20.jpeg";
import p4_21 from "../resources/images/projectphotos/project4/21.jpeg";
import p4_22 from "../resources/images/projectphotos/project4/22.jpeg";
import p4_23 from "../resources/images/projectphotos/project4/23.jpg";
import p4_24 from "../resources/images/projectphotos/project4/24.JPG";
import p4_25 from "../resources/images/projectphotos/project4/25.JPG";
import p4_26 from "../resources/images/projectphotos/project4/26.jpg";
import p4_27 from "../resources/images/projectphotos/project4/27.jpg";

import p5_20 from "../resources/images/projectphotos/project5/20.jpeg";
import p5_21 from "../resources/images/projectphotos/project5/21.jpeg";
import p5_22 from "../resources/images/projectphotos/project5/22.jpeg";
import p5_23 from "../resources/images/projectphotos/project5/23.jpeg";
import p5_24 from "../resources/images/projectphotos/project5/24.jpg";
import p5_25 from "../resources/images/projectphotos/project5/25.jpeg";
import p5_26 from "../resources/images/projectphotos/project5/26.jpg";
import p5_27 from "../resources/images/projectphotos/project5/27.jpg";

const project1Gallery = [p1_1, p1_2, p1_3, p1_4, p1_5, p1_6, p1_7, p1_8, p1_9, p1_10, p1_11, p1_12];
const project2Gallery = [p2_11, p2_12, p2_13, p2_14, p2_15, p2_16, p2_17, p2_18, p2_19, p2_20, p2_21, p2_22, p2_23, p2_24];
const project3Gallery = [p3_18, p3_19, p3_20, p3_21];
const project4Gallery = [p4_20, p4_21, p4_22, p4_23, p4_24, p4_25, p4_26, p4_27];
const project5Gallery = [p5_20, p5_21, p5_22, p5_23, p5_24, p5_25, p5_26, p5_27];

const project1Cover = p1_2;
const project2Cover = p2_11;
const project3Cover = p3_18;
const project4Cover = p4_26;
const project5Cover = p5_21;

export const projectsData = [
  {
    id: 1,
    title:
      "Курсы повышения квалификации педагогов дошкольных организаций с целью повышения эффективности учебно-воспитательного и управленческого процесса",
    city: "Алматы",
    date: "05.08 - 23.10.2024г.",
    aim: "Повышение профессиональных квалификаций руководителей и педагогов ДО в соответствии с современными методами и международными практиками",
    participantCount: 440,
    participantCategory:
      "Руководители, методисты, педагоги-психологи, воспитатели и специальные педагоги",
    imageUrl: project1Cover,
    contentSections: [
      {
        type: "heading",
        level: 2,
        text: "Содержание курса",
      },
      {
        type: "moduleList",
        modules: [
          {
            title: "Аудиторное обучение (80 ч.)",
            items: [
              "Теоретические занятия",
              "Самостоятельные работы",
              "Мастер-классы",
              "Семинары",
              "УМК (Учебно-методический комплекс)",
            ],
          },
          {
            title: "Практика на базе детских садов (28 ч.)",
            items: [
              "Посещение лучших детских садов г. Алматы",
              "Заполнение дневников практики с рефлексивным отчетом.",
            ],
          },
          {
            title: "Международный семинар",
            items: [
              "Привлечение ведущих отечественных и зарубежных экспертов в области ДО (Греция, Италия, Малайзия, Гонконг).",
              "Обмен опытом и знаниями в сфере ДО по исследованию современных практик и методик обучения, применяемых в разных странах.",
              "Методические рекомендации по направлениям.",
            ],
          },
          {
            title: "Международная стажировка",
            items: [
              "Посещение ведущих детских садов и ВУЗ-ов в Малайзии и Китае.",
              "Изучение систем образования в Польше и Германии.",
            ],
          },
        ],
      },
      {
        type: "heading",
        level: 2,
        text: "Результаты обучения",
      },
      {
        type: "achievement",
        title: "Качество успеваемости",
        value: "91%",
      },
      {
        type: "gallery",
        title: "Фотогалерея",
        images: project1Gallery.slice(0, 3),
      },
      {
        type: "heading",
        level: 2,
        text: "Международная стажировка 20 руководителей и 20 методистов ДО",
      },
      {
        type: "heading",
        level: 2,
        text: "Малайзия и Китай (руководители)",
      },
      {
        type: "moduleList",
        modules: [
          {
            title: "Университет им. Султана Идриса в г. Танджунг Малим",
            items: [
              "Имеет кафедру ДО, детский сад, Национальный научный центр по детскому развитию, автор онлайн платформы «NCDC».",
            ],
          },
          {
            title: "Международный детский сад «Ennoble» в г. Ханчжоу",
            items: [
              "Совмещает мировые подходы и модель «Всемирного развития» (WCD).",
            ],
          },
          {
            title: "Международный детский сад «EtonHouse» в г. Сучжоу",
            items: [
              "Имеет более 40 представительств в Китае и 100 филиалов по ЮВА, а именно в Китае, Японии, Корее и Сингапуре.",
            ],
          },
        ],
      },
      {
        type: "gallery",
        title: "Фотогалерея",
        images: project1Gallery.slice(3, 6),
      },
      {
        type: "heading",
        level: 2,
        text: "Польша и Германия (методисты)",
      },
      {
        type: "moduleList",
        modules: [
          {
            title: "Лесной детский сад в г. Белосток ",
            items: [
              "Представляет уникальную образовательную среду, где 80% времени дети проводят на свежем воздухе.",
            ],
          },
          {
            title: "«Polski Instytut Przedszkoli Leśnych» в г. Варшава",
            items: [
              "Ведущая организация поддерживает концепции лесных детских садов в Польше.",
            ],
          },
          {
            title: "Посещение «Die Fröbel Akademie»",
            items: [
              "Образовательный центр подготовки педагогов ДО, «Fröbel Kindergarten Wirbelwind» - детский сад в г. Берлин",
            ],
          },
        ],
      },
      {
        type: "gallery",
        title: "Фотогалерея",
        images: project1Gallery.slice(6, 9),
      },
    ],
  },
  {
    id: 2,
    title:
      "Курсы повышения квалификации школьных команд в рамках проекта «Успешная школа: управление качеством обучения через школьную команду»",
    city: "Алматы",
    date: "19.10 - 05.12.2024г.",
    aim: "Обучение команды лидеров по управлению качеством обучения в школе через развитие школьных команд",
    participantCount: 250,
    participantCategory: "Директора, заместители директора, педагоги",
    imageUrl: project2Cover,
    contentSections: [
      {
        type: "heading",
        level: 2,
        text: "Содержание курса",
      },
      {
        type: "moduleList",
        modules: [
          {
            title: "Аудиторное обучение - 200 ч.",
            items: [
              "Теоретические занятия",
              "Самостоятельные работы",
              "Мастер-классы",
              "Семинары",
              "УМК (Учебно-методический комплекс)",
            ],
          },
          {
            title: "Практика на базе школ - 80 ч.",
            items: [
              "Посещение частных школ «Nurorda», «Galaxy», лицей-интерната «Білім-Инновация» г. Алматы",
              "Обмен передовым опытом",
              "Заполнение дневников практики",
              "Разработка плана развития школы на 5 лет ",
            ],
          },
          {
            title: "Стратегическая сессия",
            items: [
              "Привлечение ведущих зарубежных экспертов в области педагогики и менеджмента в общеобразовательных организациях (Великобритания)",
            ],
          },
        ],
      },
      {
        type: "heading",
        level: 2,
        text: "Результаты обучения",
      },
      {
        type: "achievement",
        title: "Качество успеваемости",
        value: "98%",
      },
      {
        type: "gallery",
        title: "Фотогалерея",
        images: project2Gallery.slice(0, 3),
      },
      {
        type: "heading",
        level: 2,
        text: "Международная стажировка 10 школьных команд в Сингапуре",
      },
      {
        type: "moduleList",
        modules: [
          {
            title: "Наньянский технологический университет",
            items: [
              "Единственный национальный педагогический университет и главный технологический университет Сингапура.",
              "Спикеры стажировки - практикующие сотрудники Министерства образования Сингапура и ведущие эксперты в области среднего образования.",
            ],
          },
        ],
      },
      {
        type: "gallery",
        title: "Фотогалерея",
        images: project2Gallery.slice(3, 15),
      },
    ],
  },
  {
    id: 3,
    title:
      "Комплексная методическая поддержка организации образования с целью повышения эффективности учебно-воспитательного процесса» - 86 школ",
    city: "Карагандинская область",
    date: "19.08 - 08.11.2024г",
    aim: "Внедрение ценностно-ориентированного образования в учебно-воспитательный процесс школы, повышение качества преподавания предметов естественно-научного цикла",
    participantCount: 1118,
    participantCategory: "Руководители, педагоги химии, физики и биологии",
    imageUrl: project3Cover,
    contentSections: [
      {
        type: "heading",
        level: 2,
        text: "Содержание поддержки",
      },
      {
        type: "moduleList",
        modules: [
          {
            title:
              "Курсы повышения квалификации по развитию предметных компетенций педагогов физики, химии,биологии",
          },
          {
            title:
              "Курсы повышения квалификации «Құндылықтарға негізделген білім беру»",
            items: [
              "Слушатели курсового обучения были обеспечены учебно-методическим пособием «Qadam»",
            ],
          },
          {
            title: "Менторское сопровождение:",
            items: [
              "Проведены мастер-классы по работе с лабораторным оборудованием в 86 школах",
              "Было посещено 95 уроков с предоставлением обратной связи (1-2 четверти)",
            ],
          },
        ],
      },
      {
        type: "heading",
        level: 2,
        text: "Результаты",
      },
      {
        type: "achievement",
        title: "Качество успеваемости",
        value: "91%",
      },
      {
        type: "gallery",
        title: "Фотогалерея",
        images: project3Gallery,
      },
    ],
  },
  {
    id: 4,
    title:
      "Курсы повышения квалификаций педагогов организаций среднего образования в рамках проекта «Целевые школы» - Карагандинская область",
    city: "Карагандинская область",
    date: "02.12.2024 - 10.01.2025г.",
    aim: "повышение профессиональных и предметных компетенций педагогов организаций среднего образования",
    participantCount: 2599,
    participantCategory:
      "Учителя начальных классов, математики, биологии, казахского языка, географии, информатики, русского языка, физики, истории, английского языка, химии",
    imageUrl: project4Cover,
    contentSections: [
      {
        type: "heading",
        level: 2,
        text: "Результаты обучения",
      },
      {
        type: "achievement",
        title: "Качество успеваемости",
        value: "88%",
      },
      {
        type: "gallery",
        title: "Фотогалерея",
        images: project4Gallery,
      },
    ],
  },
  {
    id: 5,
    title:
      "Курсы повышения квалификаций педагогов организаций среднего образования в рамках проекта «Целевые школы» - область Жетісу",
    city: "Область Жетісу",
    date: "25.11 - 13.12.2024г.",
    aim: "повышение профессиональных и предметных компетенций педагогов организаций среднего образования",
    participantCount: 997,
    participantCategory:
      "Учителя начальных классов, математики, биологии, казахского языка, географии, информатики, русского языка, физики, истории, английского языка, химии",
    imageUrl: project5Cover,
    contentSections: [
      {
        type: "heading",
        level: 2,
        text: "Результаты обучения",
      },
      {
        type: "achievement",
        title: "Качество успеваемости",
        value: "89%",
      },
      {
        type: "gallery",
        title: "Фотогалерея",
        images: project5Gallery,
      },
    ],
  },
];
